import { render, staticRenderFns } from "./commandSidebarAddNewCustomer.vue?vue&type=template&id=63d0b1c4&"
import script from "./commandSidebarAddNewCustomer.vue?vue&type=script&lang=js&"
export * from "./commandSidebarAddNewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./commandSidebarAddNewCustomer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports